import { Slide } from "react-reveal";
import g1 from "../../assets/images/gallery/f1.jpg";
import g2 from "../../assets/images/gallery/f5.jpg";
import g3 from "../../assets/images/gallery/f10.jpg";

const HomeAbout = () => {
  return (
    <section className="section-spacing-80 cloudy-bg">
      <div className="container"> 
        <div className="large">
          <div className="section-content-container">
            <div className="about-sides-container flex">
              <div className="about-images-side">
                <ul className="about-gallery-container">
                  <li className="about-gallery-item">
                    <img src={g1} alt="Flexi Painters Portfolio" />
                  </li>
                  <li className="about-gallery-item">
                    <img src={g2} alt="Flexi Painters Portfolio" />
                  </li>
                  <li className="about-gallery-item wide">
                    <img src={g3} alt="Flexi Painters Portfolio" />
                  </li>
                </ul>
              </div>
              <div className="about-text-side">
                <div className="section-head">
                  <Slide top>
                    <h2 className="section-title">
                      <span className="flexi-gold">About</span> Flexi Painters
                    </h2>
                  </Slide>
                </div>
                <div className="section-body section-subtitles">
                  <p>
                    Flexi Painters is a Kampala-based professional painting
                    company setting higher standards for professional painting
                    services across Uganda. We do painting, spraying, and
                    decoration finishes for residential, commercial, and
                    industrial properties.
                  </p>
                  <p>
                    We work with clients who expect more than basic results —
                    clients who want more than just color and value clean
                    execution, precision, and finishes that are beautiful and
                    painted to last.
                  </p>
                </div>
                <div className="section-footer section-spacing-20">
                  <div className="section-footer-cta-container center">
                    <a
                      href="/about"
                      rel="noopener noreferrer"
                      className="button section-sub-cta"
                    >
                      Read More &rarr;
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
